// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyBxGf3NWQThTi1bPCpvV27TSgJY8mnVclU",
  authDomain: "drmatheusandrade-4a411.firebaseapp.com",
  projectId: "drmatheusandrade-4a411",
  storageBucket: "drmatheusandrade-4a411.firebasestorage.app",
  messagingSenderId: "646035151999",
  appId: "1:646035151999:web:3a784a692e3af20227334a",
  measurementId: "G-DNQCPSG62R"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

export { db, auth };
